import { render, staticRenderFns } from "./OwnClassTeacherDataTable.vue?vue&type=template&id=e290790e"
import script from "./OwnClassTeacherDataTable.vue?vue&type=script&lang=js"
export * from "./OwnClassTeacherDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports